import { useCommonMutation } from "@utils/mutations";

interface CreateTokenBody {
  label?: string;
  expires_in_days?: number;
  token_type?: "api" | "agent";
  read_only?: boolean;
}

export const useCreateApiToken = () => {
  return useCommonMutation<CreateTokenBody>({
    url: "/api/auth/tokens",
    method: "POST",
    successMessage: "Token created",
    failureMessage: "Failed to create token",
  });
};

export const useRevokeApiToken = () => {
  return useCommonMutation<{ jti: string }>({
    url: ({ jti }) => `/api/auth/tokens/${jti}`,
    method: "DELETE",
    successMessage: "Token revoked",
    failureMessage: "Failed to revoke token",
  });
};

export const useReactivateApiToken = () => {
  return useCommonMutation<{ jti: string }>({
    url: ({ jti }) => `/api/auth/tokens/${jti}/reactivate`,
    method: "POST",
    successMessage: "Token reactivated",
    failureMessage: "Failed to reactivate token",
  });
};

export const useDeleteApiToken = () => {
  return useCommonMutation<{ jti: string }>({
    url: ({ jti }) => `/api/auth/tokens/${jti}/permanent`,
    method: "DELETE",
    successMessage: "Token deleted",
    failureMessage: "Failed to delete token",
  });
};
